import { TIKTOK_COUNTRIES } from '@/config/constants';
import { useCurrentCountry } from 'utils/hooks';
import { useParams } from 'react-router-dom';
import DrawerContent from 'components/DrawerContent';

/**
 * The Google Explore row drawer, in the shape the shared Explore table's
 * `DrawerContentDefaultComponent` prop expects.
 *
 * Google's rows are a mix of categories and brands, so `paginateBy` is derived
 * per row from `dataPoint.type` and the table's own value is ignored.
 *
 * `skipPrediction` is on before a country resolves as well as in a TikTok
 * market - not the same as asking whether the market is TikTok.
 */
const GoogleExploreDrawerContent = ({ dataPoint, parentHierarchies }) => {
    const { categoryId } = useParams();
    const country = useCurrentCountry();
    const type = dataPoint?.type;
    if (!type) return null;
    const isNotTikTokMarket =
        country && !TIKTOK_COUNTRIES.includes(country.text_id);
    return (
        <DrawerContent
            source="google"
            showParentContext={false}
            skipPrediction={!isNotTikTokMarket}
            paginateBy={`${type}Id`}
            categoryId={categoryId}
            {...{ [`${type}Id`]: dataPoint.id }}
            countryId={country ? country.id : null}
            parentHierarchies={parentHierarchies}
        />
    );
};

export default GoogleExploreDrawerContent;
